import React from 'react';
import clsx from 'clsx';
import {
    CancelButton,
    ConfirmButton,
} from '../../../../../../styling/Styles';

const EditListFunctionsRow = (props) => {

    const {
        handleCancel,
        activateGenerateButton,
        deleteComps,
        editor,
        componentsInfo,
        componentsIds,
        setOpenAlert,
        setClickedEdit,
        savedPageClicked,
        selectedProject
    }=props;

    const findId = (pageName) => {
        let id = -1;
    
        const tempData = JSON.parse(localStorage.getItem('data'));
        tempData[selectedProject].pages.forEach((page) => {
          if (page.name === pageName) {
            id = page.pageId;
          }
        });
    
        return id;
    };

    //  This functions saves the changes during the proccess of edit and closes the edit list pop up window
    const updateAttributes = () => {
        
        deleteComps.forEach( (compId) => {
            
            if(compId !== -1){
                const deleteComp = editor.DomComponents.componentsById[compId];
                if(deleteComp !== undefined){
                    deleteComp.remove();
                }
            }
            
        })

        componentsInfo.forEach( (insideComp, indexInsideComp) => {

            if(componentsIds[indexInsideComp].rowId !== -1){

                const imageId = componentsIds[indexInsideComp].insideIds[0];
                const titleId = componentsIds[indexInsideComp].insideIds[1];
                const paragraphId = componentsIds[indexInsideComp].insideIds[2];

                const componentImage = editor.DomComponents.componentsById[imageId];
                const componentTitle = editor.DomComponents.componentsById[titleId];
                const componentParagraph = editor.DomComponents.componentsById[paragraphId];

                const { imageSrc } = insideComp.info;

                if(componentImage !== undefined){
                    componentImage.set('src',imageSrc)
                    if (componentsInfo[indexInsideComp].info.hrefChecked === true){
                        const { href } = componentsInfo[indexInsideComp].info;
                        
                        if( href !== ''){
                            componentImage.addAttributes({'href': href})
                        }
                                    
                        const attr = componentImage.getAttributes();
                        if (href === ''){
                            delete attr.href;
                        }      
                        delete attr.target_page;
                        componentImage.setAttributes(attr);
                    }
                    else if (componentsInfo[indexInsideComp].info.targetPageChecked === true){
                        const { targetPage } = componentsInfo[indexInsideComp].info;
                        if( targetPage  !== '' && targetPage !== undefined && targetPage !== 'undefined' ){
                            componentImage.addAttributes({target_page: findId(targetPage)})
                        }
                        
                        const attr = componentImage.getAttributes();
                        if(targetPage === undefined || targetPage === 'undefined' || targetPage === ''){
                            delete attr.target_page;
                        } 
                        delete attr.href;
                        componentImage.setAttributes(attr);
                    }

                }

                if(componentTitle !== undefined){

                    componentTitle.components(insideComp.info.titleText);

                }

                if(componentParagraph !== undefined){
                    componentParagraph.components(insideComp.info.descriptionText);
                }
            }
            else{
                const selectedComponent = editor.getSelected().attributes.components.models[0];
                const { hrefChecked } = componentsInfo[indexInsideComp].info;
                const { targetPageChecked } = componentsInfo[indexInsideComp].info;
                const imageAttributes = {
                    src: componentsInfo[indexInsideComp].info.imageSrc,
                    alt: 'Image'
                }

                if(hrefChecked === true){
                    const { href } = componentsInfo[indexInsideComp].info;
                    if( href !== ''){
                        imageAttributes.href = href
                    }
                    
                }
                else if(targetPageChecked === true){
                    const { targetPage } = componentsInfo[indexInsideComp].info;
                    if(targetPage !== '' && targetPage !== 'undefined'){
                        imageAttributes.target_page = targetPage
                    }
                } 


                selectedComponent.append({  
                    type: 'row',
                    tagName: 'tr',
                    components: [
                        {
                          type: 'cell', 
                          tagName: 'td',
                          components: [
                            {   
                                type: 'image', 
                                attributes: imageAttributes,
                                classes: ["list-item-image"],
                            }
                          ],
                          classes: ['list-cell-left']
                        },
                        {
                          type: 'cell', 
                          tagName: 'td',
                          components: [
                            {tagName: 'h1', content: componentsInfo[indexInsideComp].info.titleText, classes:['card-title']},
                            {tagName: 'p', content: componentsInfo[indexInsideComp].info.descriptionText, classes:['card-text']},
                            ],
                          classes: ['list-cell-right']
                          },
                    ],
                    
                    classes: ["list-item-content"]
                  
                })
            
            }

            

        })
        
        setOpenAlert(false);
        setClickedEdit(false);
        savedPageClicked();
    }

    return(
        <div className={clsx('flex-container', 'spacingDownDiv', 'spacingTopDiv')} 
            style={{
                justifyContent:'space-between',
                display: 'flex',
                flexDirection: 'row',
                minWidth: '30vw'
            }}

        >
            <div >
                <CancelButton 
                    onClick={handleCancel}
                >
                    Cancel
                </CancelButton >
            </div>
            <div className={clsx('flexRowDirection')}>
                <ConfirmButton 
                    onClick={updateAttributes}
                >
                    Save
                </ConfirmButton>
                <div> &nbsp;</div>
                <ConfirmButton
                    onClick={activateGenerateButton}
                >
                    Generate block
                </ConfirmButton>
            </div>
        </div>
    )

}

export default EditListFunctionsRow;